import React, { useEffect, useRef } from 'react'
import './pageoverLay.css'
import rhybusloader from '../../assets/images/rhybusicon.png'

const PageOverlay = () => {
    const overlayRef = useRef<HTMLDivElement>(null)

    useEffect(() => {
        const activeElement = document.activeElement as HTMLElement | null

        activeElement?.blur()
        overlayRef.current?.focus()

        return () => {
            activeElement?.focus?.()
        }
    }, [])

    const swallowEvent = (event: React.SyntheticEvent) => {
        event.preventDefault()
        event.stopPropagation()
    }

    const handleKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
        if (event.key === 'Tab') {
            event.preventDefault()
            event.stopPropagation()
        }
    }

    return (
        <div
            ref={overlayRef}
            className="submit-bg"
            id="pageoverlay"
            role="dialog"
            aria-modal="true"
            aria-label="Loading"
            tabIndex={0}
            onClick={swallowEvent}
            onKeyDown={handleKeyDown}
            onMouseDown={swallowEvent}
            onMouseUp={swallowEvent}
            onPointerDown={swallowEvent}
            onPointerUp={swallowEvent}
            onTouchStart={swallowEvent}
            onTouchEnd={swallowEvent}
        >
            <div className='copying'>
                  <div className="page-loader">
                <div className="page-loader-spinner"><img src={rhybusloader} alt="loader" /> </div>
                <div>Loading...</div>
            </div>
            </div>   
            </div>
    )
}

export default PageOverlay
